// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-4102d013]{max-width:300px;margin-left:auto;margin-right:auto}@media(max-width:400px){.content__img[data-v-4102d013]{width:140px}.content__title[data-v-4102d013]{font-size:20px!important;font-weight:600!important}}.content__extras[data-v-4102d013]{gap:15px}@media(max-width:550px){.content__extras[data-v-4102d013]{flex-wrap:wrap}}", ""]);
// Exports
module.exports = exports;
